<div class="ui-filter-bar" role="tablist" aria-label="Filters">
  @for (filter of filters(); track filter.value) {
    <button
      type="button"
      class="ui-filter-bar__item"
      [class.ui-filter-bar__item--active]="filter.value === selected()"
      [class.ui-filter-bar__item--disabled]="filter.disabled ?? false"
      [disabled]="filter.disabled ?? false"
      (click)="select(filter.value, filter.disabled)"
    >
      {{ filter.label | uiLabelTranslate }}
    </button>
  }
</div>
